module.exports = __webpack_public_path__ + "static/about-top-image@2x-1483f0cb1b8e54d212c4b03a7ea0a5a2.jpg";